import { AppConfiguration2 } from '@/shared/app/model/AppConfiguration2';
import { readSiteAndPageNumber } from '@/shared/app/templating/read-site-and-page';
import { UniComponents } from '@/shared/uni/templating/uni-components';
import init from '../shared/main';
import sites from './_site';

(async () => {
  const numbers = readSiteAndPageNumber(window.location.pathname);
  const page = sites[numbers.siteNo]?.pages[numbers.pageNo];

  if (!page) throw new Error('Oops. No page to load. Check URL.');

  const appConfiguration: AppConfiguration2 = {
    page,
    components: {
      DishLayout: () => import('./dish/ui/DishLayout.vue'),
      Dish: () => import('./dish/ui/Dish.vue'),
      ItecDish: () => import('./_site/3_itec_boisfleury/ui/ItecDish.vue'),
      TText: () => import('@shared/uni/templating/components/text/ui/TText.vue'),
      TVideo: () => import('@shared/video/ui/Video.vue'),
      ...UniComponents,
    },
  };

  init(appConfiguration);
})();
